import React from 'react';

import { FooterSubcomponentProps } from '.';
import { Grid, Link, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import ContactInfoComponent from './ContactInfoSection';
import { getKeyFromLinkSection } from './utils';

const DesktopFooter: React.FC<FooterSubcomponentProps> = ({
  linkSections,
  contactInfoSection,
  textColor,
  accentTextColor,
  isShowingCart,
}) => {
  const theme = useTheme();
  const generateStyles = (theme: Theme) => ({
    maxWidth: theme.breakpoints.values.contentMaxWidth,
    padding: '0 1rem',
    margin: 'auto',
    marginBottom: isShowingCart ? '2.5rem' : undefined,
    ['.links-section']: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },
  });
  const styles = generateStyles(theme);

  return (
    <Grid container sx={[{ flexDirection: 'column' }, styles]}>
      <Grid>
        <Grid
          container
          direction="row"
          className="links-section"
          sx={{
            justifyContent: 'space-between',
          }}
        >
          {linkSections.map((linkSection, idx) => {
            const { header, links } = linkSection;
            return (
              <Grid key={getKeyFromLinkSection(linkSection, idx)}>
                <Grid
                  container
                  sx={{
                    flexDirection: 'column',
                    alignItems: 'baseline',
                  }}
                >
                  {header && (
                    <Typography variant="h6" sx={{ color: accentTextColor }}>
                      {header}
                    </Typography>
                  )}
                  {links?.map((link) => (
                    <Grid
                      key={`${link.url}-${link.displayText}`}
                      sx={{
                        padding: '0.25rem 0',
                      }}
                    >
                      <Link
                        href={link.url}
                        underline="hover"
                        target={link.target}
                      >
                        <Typography variant="caption" sx={{ color: textColor }}>
                          {link.displayText}
                        </Typography>
                      </Link>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            );
          })}
          <Grid>
            <ContactInfoComponent {...contactInfoSection} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DesktopFooter;
